import { render, staticRenderFns } from "./CodiumSelectize.vue?vue&type=template&id=63069a6e"
import script from "./CodiumSelectize.vue?vue&type=script&lang=js"
export * from "./CodiumSelectize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports